/**
 * ehr#681 follow-up: what the save card says on each screen that took the drawer's save
 * confirmation (components/SaveToast.tsx). The card names what was saved; a failure card says
 * "Not saved" over the reason. No em or en dashes; "payor", never "payer".
 */
import { ApiError } from './api.js';

/** The server's own reason when it gave one, else `fallback`. */
export const reasonOf = (e: unknown, fallback: string): string =>
  e instanceof ApiError && e.message ? e.message : fallback;

/** Follow-up tab (client drawer): a date saves the follow-up; no date clears it. */
export const followupSavedText = (dateISO: string) =>
  dateISO ? 'Follow-up saved' : 'Follow-up cleared';
export const followupErrText = (e: unknown) =>
  `Could not save the follow-up: ${reasonOf(e, 'please try again.')}`;

/** Progress note Save Draft. */
export const NOTE_DRAFT_SAVED = 'Draft saved';
export const noteDraftErrText = (e: unknown) => reasonOf(e, 'Save failed.');

/** Settings > Email & calendar (Sync settings): each section saves on its own. */
export const syncSavedText = (which: 'calendar' | 'mail') =>
  which === 'calendar' ? 'Calendar settings saved' : 'Email settings saved';
export const syncErrText = (e: unknown) => reasonOf(e, 'Could not save. Try again.');

/** Settings > Payors. */
export const payorSavedText = (isNew: boolean) => (isNew ? 'Payor added' : 'Payor saved');
export const payorToggledText = (name: string, nowActive: boolean) =>
  `${name} turned ${nowActive ? 'on' : 'off'}`;
export const payorErrText = (e: unknown) => reasonOf(e, 'Something went wrong');

/** Settings > CPT codes. */
export const cptSavedText = (code: string, isNew: boolean) =>
  `CPT code ${code} ${isNew ? 'added' : 'saved'}`;
export const CPT_FIX_FIELDS = 'Fix the fields in red first.';
export const cptErrText = (e: unknown) => reasonOf(e, 'Something went wrong');

/** Authorizations (client drawer). */
export const authSavedText = (isEdit: boolean) =>
  isEdit ? 'Authorization saved' : 'Authorization added';
export const authErrText = (e: unknown) =>
  e instanceof ApiError && e.code !== 'VALIDATION' && e.message
    ? e.message
    : 'Check the fields and try again.';
